import { render, staticRenderFns } from "./houses.vue?vue&type=template&id=f858f6e6&scoped=true&"
import script from "./houses.vue?vue&type=script&lang=js&"
export * from "./houses.vue?vue&type=script&lang=js&"
import style0 from "./houses.vue?vue&type=style&index=0&id=f858f6e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f858f6e6",
  null
  
)

component.options.__file = "houses.vue"
export default component.exports